import { useEffect, useState, useCallback, useMemo } from 'react';
import './index.scss';
import { CommmonGet } from '@/util/network/api';
import { selectSchoolId, selectSchoolInfo, selectSchoolLevel } from "../../../store/reducers/schoolInfo";
import { selectUserId, selectUserInfo } from "../../../store/reducers/userInfo";
import { Table } from 'antd';
import moment from "moment";
import { useSelector } from 'react-redux';
import { lgAlert } from 'lancoo-web-ui';


// 录取状态枚举
const ADMISSION_STATUS = {
  0: { text: '待录取', color: '#ff6600' },
  1: { text: '已录取', color: '#009900' },
  4: { text: '拟录取', color: '#0066ff' },
  default: { text: '未录取', color: '#ff0000' }
};

// 缴费状态枚举
const PAY_STATUS = {
  1: { text: '未缴费', color: '#ff0000' },
  2: { text: '已缴费', color: '#009900' }
};

const AdmissDetail = (props) => {
  const { data:infoData, admissionInfo } = props;
  const userId = useSelector(selectUserId);
  const schoolId = useSelector(selectSchoolId);
  // 状态
  const [hasVolunteer, setHasVolunteer] = useState(false);
  //报名信息
  const [selfInfo, setSelfInfo] = useState<any>({});
  //数据项
  const [planOtherInfo, setPlayOtherInfo] = useState<any>({});

  const [payVisible, setPayVisible] = useState(false);

  // API
  const API = {
    hasVolunteer: 'admissionManage/hasVolunteer',
    getSelfInfo: 'admissionManage/userInfo',
    getPlanOtherInfo: 'admissionManage/planOtherInfo'
  };

  // 获取志愿状态
  useEffect(() => {
    if (!infoData.planId) return;
    CommmonGet(API.hasVolunteer, { planId: infoData.planId }).then((res: any) => {
        setHasVolunteer(res.data||{});
    }).catch(error => {
        setHasVolunteer(false);
    })
    console.log(infoData, 'infoData')
    CommmonGet(API.getSelfInfo, { planId: infoData.planId, userId, templateId: infoData.templateId, apply: false}).then((res: any) => {
      setSelfInfo(res.data||{});
    }).catch(error => {
        setHasVolunteer(false);
    })

    CommmonGet(API.getPlanOtherInfo, { planId: infoData.planId }).then((res: any) => {
      setPlayOtherInfo(res.data||{});
    }).catch(error => {
        setHasVolunteer(false);
    })
    
  }, [infoData.planId]);

  const goPay = () => {
    let alert = lgAlert.show({
      duration: 0,
      content: '电脑Web端暂不支持使用此功能',
      description: "请前往手机上缴费",
      tipType: 'info',
      tipSize: 'big',
      tipMouldType: 'A',
      closeText: "知道了",
      showConfirm: false,
      onConfirm: () => {
          lgAlert.close(alert.index)
      }
    });

  }

  const enrollColumns = useMemo(()=>{
    return [
      {
        title: '录取状态',
        dataIndex: 'admissionStatus',
        key: 'admissionStatus',
        render: (value)=>{
          return renderAdmissionStatus(value);
        }
      },
      {
        title: '录取原因',
        dataIndex: 'reason',
        key: 'reason',
        render: (value)=>value||"--"
      },
      {
        title: '录取专业',
        dataIndex: 'selfMajor',
        key: 'selfMajor',
        render: () => {
          let result = "--";
          if(admissionInfo?.majorCode){
            result = admissionInfo?.majorCode;
          } else if(selfInfo.applyForMajor && planOtherInfo?.basicField?.applyForMajor?.options){
            planOtherInfo?.basicField?.applyForMajor?.options.forEach(item=>{
              if(item.value === selfInfo.applyForMajor){
                result = item.name;
              }
            })
          }
          return result;
        }
      },
      {
        title: '录取时间',
        dataIndex: 'admissionTime',
        key: 'admissionTime'
      },
    ];
  }, [selfInfo, planOtherInfo]);

  const payColumns = useMemo(()=>{
    return [
      {
        title: '缴费信息项',
        dataIndex: 'payType',
        key: 'payType',
      },
      {
        title: '缴费金额',
        dataIndex: 'payNum',
        key: 'payNum',
      },
      {
        title: '缴费状态',
        dataIndex: 'payStatus',
        key: 'payStatus',
        render: (value) => {
          value = value||1;
          let one = PAY_STATUS[value];
          return <span style={{color: one.color}}>{one.text}</span>
        }
      },
      {
        title: '缴费时间',
        dataIndex: 'payTime',
        key: 'payTime',
        render: (value)=>value||"--"
      },
      {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        onCell: (_, index) => ({
          rowSpan: index === 0 ? 2: 0,
        }),
        render: (value, row) => {
          if(row.payStatus === 1){
            return <span className='pay-btn' onClick={goPay}>去缴费</span>
          } else {
            return <span>--</span>
          }
        }
      },
    ];
  }, [infoData]);

  // 渲染状态
  const renderAdmissionStatus = (status) => {
    const config = ADMISSION_STATUS[status] || ADMISSION_STATUS.default;
    return (
      <span style={{ color: config.color }}>
        {config.text}
      </span>
    );
  };

  const payDataList = useMemo(()=>{
    // 缴费状态和金额计算 - 参考PaymentStatus的实现
    const textbookFeeState = selfInfo.textbookFeeState ?? 0;
    const accommodationFeeState = selfInfo.accommodationFeeState ?? 0;

    // 使用infoData中的金额数据，参考PaymentStatus的实现
    const textbookFee = Number(infoData?.textbookFee) || 0;
    const accommodationFee = Number(infoData?.accommodationFee) || 0;

    const payTime = selfInfo?.feeDate? moment(selfInfo?.feeDate).format("YYYY-MM-DD HH:mm"):"";
    let arr = [];
    if (textbookFeeState !== 0 && accommodationFeeState !== 0) {
        // 共生状态：课本费和住宿费都需要缴费
        arr = [
          {
            payType: "课本费",
            payNum: textbookFee,
            payStatus: textbookFeeState,
            payTime
          },
          {
            payType: "住宿费",
            payNum: accommodationFee,
            payStatus: accommodationFeeState,
            payTime
          },
        ]
    } else if (textbookFeeState !== 0) {
      arr = [
        {
          payType: "课本费",
          payNum: textbookFee,
          payStatus: textbookFeeState,
          payTime
        }
      ]
    } else if (accommodationFeeState !== 0) {
      arr = [
        {
          payType: "住宿费",
          payNum: accommodationFee,
          payStatus: accommodationFeeState,
          payTime
        },
      ]
    }
    return arr;
  }, [infoData, selfInfo]);

  //鼓励话语
  const encourageWord = useMemo(()=>{
    if(infoData?.admissionInfo?.admissionStatus === 1){
      return (<div className='encourage-word'>
        <svg viewBox="0 0 1024 1024" width="32" height="32"><path d="M333.5 411.4a35.4 67.6 0 1 0 70.8 0 35.4 67.6 0 1 0-70.8 0Z" fill="#ff6600" p-id="4402"></path><path d="M620.8 411.4a35.4 67.6 0 1 0 70.8 0 35.4 67.6 0 1 0-70.8 0Z" fill="#ff6600" p-id="4403"></path><path d="M512.6 807.2c-141.8 0-257.3-103.8-257.3-231.4 0-20.7 16.8-37.5 37.5-37.5h439.5c20.7 0 37.5 16.8 37.5 37.5 0 127.6-115.4 231.4-257.2 231.4z m-177-193.9c19.6 68.2 91.5 118.9 176.9 118.9s157.3-50.7 176.9-118.9H335.6z" fill="#ff6600" p-id="4404"></path><path d="M512.6 960.2c-247.2 0-448.3-201.1-448.3-448.3 0-48.8 7.8-96.9 23.2-142.8 6.6-19.6 27.8-30.1 47.5-23.6 19.6 6.6 30.2 27.9 23.6 47.5-12.8 38.2-19.3 78.2-19.3 118.9 0 205.9 167.5 373.3 373.3 373.3s373.3-167.5 373.3-373.3-167.5-373.3-373.3-373.3c-116.8 0-224.7 53.1-296 145.8-12.7 16.4-36.2 19.4-52.6 6.9-16.4-12.6-19.5-36.2-6.9-52.6C242.7 127.3 372.3 63.5 512.6 63.5c247.2 0 448.3 201.1 448.3 448.3S759.8 960.2 512.6 960.2z" fill="#ff6600"></path></svg>
        <p>恭喜你被录取啦！期待你的加入~</p>
        <p>梦想启航，录取只是开始，加油~</p>
      </div>)
    } else {
      return (
        <div className='encourage-word'>
          <svg viewBox="0 0 1024 1024" width="32" height="32"><path d="M333.5 411.4a35.4 67.6 0 1 0 70.8 0 35.4 67.6 0 1 0-70.8 0Z" fill="#ff6600" p-id="4402"></path><path d="M620.8 411.4a35.4 67.6 0 1 0 70.8 0 35.4 67.6 0 1 0-70.8 0Z" fill="#ff6600" p-id="4403"></path><path d="M512.6 807.2c-141.8 0-257.3-103.8-257.3-231.4 0-20.7 16.8-37.5 37.5-37.5h439.5c20.7 0 37.5 16.8 37.5 37.5 0 127.6-115.4 231.4-257.2 231.4z m-177-193.9c19.6 68.2 91.5 118.9 176.9 118.9s157.3-50.7 176.9-118.9H335.6z" fill="#ff6600" p-id="4404"></path><path d="M512.6 960.2c-247.2 0-448.3-201.1-448.3-448.3 0-48.8 7.8-96.9 23.2-142.8 6.6-19.6 27.8-30.1 47.5-23.6 19.6 6.6 30.2 27.9 23.6 47.5-12.8 38.2-19.3 78.2-19.3 118.9 0 205.9 167.5 373.3 373.3 373.3s373.3-167.5 373.3-373.3-167.5-373.3-373.3-373.3c-116.8 0-224.7 53.1-296 145.8-12.7 16.4-36.2 19.4-52.6 6.9-16.4-12.6-19.5-36.2-6.9-52.6C242.7 127.3 372.3 63.5 512.6 63.5c247.2 0 448.3 201.1 448.3 448.3S759.8 960.2 512.6 960.2z" fill="#ff6600"></path></svg>
          <p>别灰心，请继续加油哦~</p>
          <p>前路漫漫亦灿灿，录取与否皆为序章。</p>
          <p>人生这场马拉松，才刚起跑！</p>
        </div>
      )
    }
  }, []);

  return (
    <div className='payDetail'>
      <div className='enroll-title'>录取信息</div>
      <Table dataSource={[infoData.admissionInfo||{}]} columns={enrollColumns} pagination={false} />
      <div className='enroll-title'>
        缴费信息
        <span style={{color: '#ff6600'}}>缴费后，仅支持线下退费，退费请联系招生办！</span>
      </div>
      <Table dataSource={payDataList} columns={payColumns} pagination={false} />

      {encourageWord}
    </div>
  );
};

export default AdmissDetail;